module.exports = {
  IMG_ARR: ['timmarshal', 'johnsalzarulo', 'jeremythomas', 'iandooley'],

  BG_ARR: ['#ECEFF1', '#B0BEC5', '#73909C', '#FF9802', '#27B87B', '#1BCFB4', '#009588', '#684DB5', '#2E79BA', '#192D4E'],

  FULL_BRD_FAV_ADD: 'FULL_BRD_FAV_ADD',

  FULL_BRD_FAV_DEL: 'FULL_BRD_FAV_DEL',
  UPDATE_BOARD_DATA: 'UPDATE_BOARD_DATA'
};
